'use strict';

function validateBirthdayFields(target) {
    const $birthdayFields = $(target).closest('.birthday-fields'),
        $month = $birthdayFields.find('.input-select.birthmonth :selected'),
        $day = $birthdayFields.find('.input-select.dob :selected'),
        $year = $birthdayFields.find('.input-text.birthyear'),
        $errorPlacement = $(target).closest('form').find('.birthday-row:not(.birthday-fields) .form-label'),
        yearRegex = /(?:(?:19|20|21)[0-9]{2})$/, // to begin year from 1900
        leapYear = new Date($year.val(), 1, 29).getDate() === 29;

    // check one of the field having invalid entry
    if ($month.val() === '00' || $day.val() === '00' || !yearRegex.test($year.val())) {
        $errorPlacement.find('.error-placement').length === 0 && $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_DATE + '</span></div>').insertAfter($errorPlacement.find('.form-label-txt'));
    }
    // check if year is a leap year
    else if ($month.val() == '02' && !leapYear && $day.val() > 28) {
        $errorPlacement.find('.error-placement').length === 0 && $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_DATE + '</span></div>').insertAfter($errorPlacement.find('.form-label-txt'));
    }
    // check if year is not a leap year
    else if ($month.val() == '02' && leapYear && $day.val() > 29) {
        $errorPlacement.find('.error-placement').length === 0 && $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_DATE + '</span></div>').insertAfter($errorPlacement.find('.form-label-txt'));
    }
    // check if month has 30 days
    else if (($month.val() === '04' || $month.val() === '06' || $month.val() === '09' || $month.val() === '11') && $day.val() > 30) {
        $errorPlacement.find('.error-placement').length === 0 && $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_DATE + '</span></div>').insertAfter($errorPlacement.find('.form-label-txt'));
    }
    // to check user is less tha 16 yrs of age
    else if (!validate16YrsOfAge($day.val(), $month.val(), $year.val())) {
        $errorPlacement.find('.error-placement').length === 0 && $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_BIRTHDAY + '</span></div>').insertAfter($errorPlacement.find('.form-label-txt'));
    } else {
        $errorPlacement.find('.error-placement').remove();
        getBirthday($month.val(), $day.val(), $year.val());
    }

    // to remove error when feild reset
    if ($month.val() === '00' && $day.val() === '00' && $year.val() === '') {
        $errorPlacement.find('.error-placement').length && $errorPlacement.find('.error-placement').remove();
        getBirthday($month.val(), $day.val(), $year.val());
    }

    // to enable submit button
    if ($(target).closest('form').find('span.error').length === 0) {
        $(target).closest('form').find('button[type="submit"]').prop('disabled', false);
    }
}

function validate16YrsOfAge(day, month, year) {
    var dd = parseInt(day),
        mm = parseInt(month),
        yy = parseInt(year);
    return new Date(yy + 16, mm - 1, dd) <= new Date();
}

function validateBirthdayEvents () {
    $('.birthday-fields .input-text.birthyear').on('change', function (event) {
        validateBirthdayFields(event.target);
    });
    $('.birthday-fields .input-select.dob').on('selectmenuchange change', function (event) {
        var $birthdayFields = $(this).closest('.birthday-fields'),
            $month = $birthdayFields.find('.input-select.birthmonth :selected'),
            $year = $birthdayFields.find('.input-text.birthyear');
        if ($month.val() !== '' && $year.val() !== '') {
            validateBirthdayFields(event.target);
        }
    });

    $('.birthday-fields .input-select.birthmonth').on('selectmenuchange change', function (event) {
        var $birthdayFields = $(this).closest('.birthday-fields'),
            $day = $birthdayFields.find('.input-select.dob :selected'),
            $year = $birthdayFields.find('.input-text.birthyear');
        if ($day.val() !== '' && $year.val() !== '') {
            validateBirthdayFields(event.target);
        }
    });
}

function setBirthday() {
    const $editProfileForm = $('.form-edit-profile');
    const birthmonthMenu = $editProfileForm.find('#dwfrm_profile_customer_birthmonth');
    const dobMenu = $editProfileForm.find('#dwfrm_profile_customer_dob');
    const birthmonth = ('0' + birthmonthMenu.data('birthmonth')).slice(-2);
    const dob = ('0' + dobMenu.data('dob')).slice(-2);

    function initAndRefreshSelectMenu(menu, value) {
        if (value && value > 0) {
            menu.val(value);
            menu.selectmenu("refresh");
        }
    }

    // Initialize and refresh select menus for Birth Month and Birth Day
    initAndRefreshSelectMenu(birthmonthMenu, birthmonth);
    initAndRefreshSelectMenu(dobMenu, dob);

    //Birth Year
    const $birthyearInput = $editProfileForm.find('input.birthyear');
    const birthyear = $birthyearInput.data('birthyear');
    $birthyearInput.val(birthyear);

    getBirthday(birthmonth, dob, birthyear);
}

function getBirthday(birthmonth, dob, birthyear) {
	let birthday = '';
    const $editProfileForm = $('.form-edit-profile');
	// Validate each component individually
	const validMonth = (birthmonth !== '00' && Number(birthmonth) > 0) ? birthmonth : '';
	const validDay = (dob !== '00' && Number(dob) > 0) ? dob : '';
	const validYear = (birthyear !== '0000' && Number(birthyear) > 0) ? birthyear : '';

	if (validMonth && validDay && validYear) {
		birthday = [validMonth, '/', validDay, '/', validYear].join('');
	} else {
		// Reset invalid fields to default values
		$editProfileForm.find('.birthmonth select').val('00');
		$editProfileForm.find('.dob select').val('00');
	}

	$('.form-edit-profile .birthday input').val(birthday);
}


var validateBirthdayModule = {	
    init: function () {
        validateBirthdayEvents();
        setBirthday();
    }
};

export default validateBirthdayModule;
